/**
 * Turning a demo into a file on the visitor's disk.
 *
 * This is not a convenience feature — it is how the page's thesis ("your
 * files, your machine") stops being a claim and becomes a receipt (D10 /
 * LANDING_PAGE.md §5). Every demo ends here.
 */

export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  // Revoke on the next frame — revoking synchronously can cancel the download
  // in Safari before it starts.
  requestAnimationFrame(() => URL.revokeObjectURL(url))
}

export function downloadText(filename: string, text: string, mime = 'text/plain'): void {
  downloadBlob(filename, new Blob([text], { type: `${mime};charset=utf-8` }))
}

/** RFC 4180: quote when the value contains a comma, quote or newline. */
function csvCell(value: unknown): string {
  const s = value == null ? '' : String(value)
  return /[",\n\r]/.test(s) ? `"${s.replaceAll('"', '""')}"` : s
}

export function toCsv(
  columns: { id: string; label?: string }[],
  rows: Record<string, unknown>[],
): string {
  const header = columns.map((c) => csvCell(c.label ?? c.id)).join(',')
  const body = rows.map((r) => columns.map((c) => csvCell(r[c.id])).join(','))
  return [header, ...body].join('\n') + '\n'
}
